"use strict";

var _typeof = require("@babel/runtime-corejs2/helpers/typeof");

var _Object$keys = require("@babel/runtime-corejs2/core-js/object/keys");

var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs2/core-js/object/get-own-property-symbols");

var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor");

var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptors");

var _Object$defineProperties = require("@babel/runtime-corejs2/core-js/object/define-properties");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

var _WeakMap = require("@babel/runtime-corejs2/core-js/weak-map");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _uuid = require("uuid");

var _Check = _interopRequireDefault(require("@paprika/icon/lib/Check"));

var _helpers = require("@paprika/helpers");

var sc = _interopRequireWildcard(require("./Radio.styles"));

var _Group = _interopRequireDefault(require("./components/Group"));

var _RadioInputPropsCollector = _interopRequireDefault(require("./RadioInputPropsCollector"));

var _types = _interopRequireDefault(require("./types"));

var _excluded = ["a11yText", "children", "isChecked", "isDisabled", "name", "canDeselect", "onClick", "size", "tabIndex", "value"];

function _getRequireWildcardCache(nodeInterop) { if (typeof _WeakMap !== "function") return null; var cacheBabelInterop = new _WeakMap(); var cacheNodeInterop = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? _Object$getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { _Object$defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

var noop = function noop() {};

function Radio(props) {
  var a11yText = props.a11yText,
      children = props.children,
      isChecked = props.isChecked,
      isDisabled = props.isDisabled,
      name = props.name,
      canDeselect = props.canDeselect,
      onClick = props.onClick,
      size = props.size,
      tabIndex = props.tabIndex,
      value = props.value,
      moreProps = (0, _objectWithoutProperties2["default"])(props, _excluded);

  var _React$useState = _react["default"].useState(function () {
    return "radio_".concat((0, _uuid.v4)());
  }),
      _React$useState2 = (0, _slicedToArray2["default"])(_React$useState, 1),
      radioId = _React$useState2[0];

  var inputRef = _react["default"].useRef(null);

  var extendedInputProps = (0, _helpers.extractChildrenProps)(children, _RadioInputPropsCollector["default"]);

  var handleKeyDown = function handleKeyDown(event) {
    if ( // Prevent scrolling the page with a spacerbar keypress
    event.key === " " || // Prevent submitting forms in IE/Edge with and enter keypress
    event.key === "Enter") {
      event.preventDefault();
    }
  };

  var handleKeyUp = function handleKeyUp(event) {
    var isTriggerKey = event.key === " "; // space key

    if (!isDisabled && isTriggerKey) {
      onClick();
    }
  };

  var styleProps = {
    hasLabel: !!children,
    size: size
  };

  var inputProps = _objectSpread(_objectSpread({
    onClick: onClick,
    checked: isChecked,
    disabled: isDisabled,
    name: name,
    onKeyDown: handleKeyDown,
    onKeyUp: handleKeyUp,
    ref: inputRef,
    tabIndex: tabIndex,
    type: "radio",
    value: value
  }, extendedInputProps), {}, {
    id: radioId
  });

  if (a11yText) inputProps["aria-label"] = a11yText;
  return /*#__PURE__*/_react["default"].createElement(sc.Radio, (0, _extends2["default"])({
    "data-pka-anchor": "radio"
  }, styleProps, moreProps), /*#__PURE__*/_react["default"].createElement("input", (0, _extends2["default"])({}, inputProps, {
    onChange: noop
  })), /*#__PURE__*/_react["default"].createElement("label", {
    onKeyUp: handleKeyUp,
    className: canDeselect ? "deselectable" : "",
    htmlFor: radioId
  }, children, canDeselect ? /*#__PURE__*/_react["default"].createElement(_Check["default"], {
    className: "radio-icon",
    "aria-hidden": true,
    "data-pka-anchor": "radio.icon.check"
  }) : /*#__PURE__*/_react["default"].createElement("div", {
    className: "radio-icon radio-solid-background",
    "data-pka-anchor": "radio.icon.check"
  })));
}

Radio.types = _types["default"];
var propTypes = {
  /** Used for aria-label on the radio input  */
  a11yText: _propTypes["default"].string,

  /** Describe if the radio started as selected or not */
  canDeselect: _propTypes["default"].bool,

  /** Used for label contents */
  children: _propTypes["default"].node,

  /* Controls if the radio is checked or not, never combine it with defaultIsChecked */
  isChecked: _propTypes["default"].bool,

  /** Describe if the radio is disabled or not */
  isDisabled: _propTypes["default"].bool,

  /** Describe if the radio started as checked or not */
  defaultIsChecked: _propTypes["default"].bool,

  /** Name provided for accessibility */
  name: _propTypes["default"].string,

  /** onClick provided by parent Group component */
  onClick: function onClick() {},

  /** Size provided by parent Group component */
  size: _propTypes["default"].oneOf([Radio.types.size.SMALL, Radio.types.size.MEDIUM, Radio.types.size.LARGE]),

  /** Value for tabindex attribute to override the default of 0. */
  tabIndex: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),

  /** Value applied to the input if needed. */
  value: _propTypes["default"].string
};
var defaultProps = {
  a11yText: null,
  canDeselect: false,
  children: null,
  defaultIsChecked: false,
  isChecked: false,
  isDisabled: false,
  name: "",
  onClick: function onClick() {},
  size: Radio.types.size.MEDIUM,
  tabIndex: 0,
  value: ""
};
Radio.displayName = "Radio";
Radio.propTypes = propTypes;
Radio.defaultProps = defaultProps;
Radio.Group = _Group["default"];
Radio.Input = _RadioInputPropsCollector["default"];
var _default = Radio;
exports["default"] = _default;
//# sourceMappingURL=Radio.js.map